/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : PoliciesTab.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { HandleApiActions, userManagementApis } from "../../../redux/actions";
import ChipsSelectField from "../../../components/customComponentsV2/common/select/ChipsSelectField";

const PoliciesTab = ({
  selectedRole,
  selectedPolicies,
  setSelectedPolicies,
  policyDefIds,
  setPolicyDefIds,
  listOfPolicies,
  handleAttach,
  handleDetach,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedRole?.role_id) return;

    const fetchPolicies = async () => {
      try {
        const resp = await Promise.resolve(
          dispatch(
            HandleApiActions({
              ...userManagementApis.get_roleRP_ddh_ucm,
              api_name: `/UCM/role-policy/${Number.parseInt(
                selectedRole.role_id,
                10
              )}/policies`,
            })
          )
        );

        if (!resp?.error) {
          setSelectedPolicies(
            resp?.data?.rolePolicies?.map((data) => ({
              label: data?.policy_key,
              value: data?.policy_def_id,
              actions: data?.actions,
            })) || []
          );
        }
      } catch (error) {
        console.error("Error fetching policies:", error);
      }
    };

    fetchPolicies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedRole?.role_id, setSelectedPolicies]);

  return (
    <ChipsSelectField
      isAttachDetach
      label="Policies"
      placeholder="Select Policies"
      listValues={selectedPolicies}
      setListValues={setSelectedPolicies}
      selectedValue={policyDefIds}
      setSelectedValue={setPolicyDefIds}
      handleAttach={handleAttach}
      handleDetach={handleDetach}
      optionsList={(listOfPolicies || [])
        .filter(
          (item) =>
            !(selectedPolicies || []).some((p) => p?.value === item?.policyId)
        )
        .map((data) => ({
          label: data?.policyName,
          value: data?.policyId,
          actions: data?.actions,
        }))}
    />
  );
};

PoliciesTab.propTypes = {
  selectedRole: PropTypes.shape({
    role_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  selectedPolicies: PropTypes.array,
  setSelectedPolicies: PropTypes.func,
  policyDefIds: PropTypes.any,
  setPolicyDefIds: PropTypes.func,
  listOfPolicies: PropTypes.array,
  handleAttach: PropTypes.func,
  handleDetach: PropTypes.func,
};

export default PoliciesTab;
